// import React, { StrictMode } from "react";
// import { createRoot } from "react-dom/client";
// import App from "./App"; // Import the App component from App.js
// // import "./styles.css";
// import * as serviceWorker from './serviceWorker';

// const rootElement = document.getElementById("root");

// if (rootElement) {
//   const root = createRoot(rootElement);

//   root.render(
//     // <StrictMode>
//     //   <App />
//     // </StrictMode>
//     <App />
//   );
// } else {
//   console.error("Root element with ID 'app' not found in the DOM.");
// }
// serviceWorker.unregister();

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
